import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaTrophy } from "react-icons/fa";
import avatarImg from "../../Images/Avtar_images.jpg.jpeg";

function Dashboard() {
  const [student, setStudent] = useState(null);
  const [exams, setExams] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [leaderboard, setLeaderboard] = useState([]);
  const [currentStudentScore, setCurrentStudentScore] = useState(0);
  const [currentStudentRank, setCurrentStudentRank] = useState(0);
 

  useEffect(() => {
    const studentData = JSON.parse(localStorage.getItem("student"));
    if (studentData) {
      setStudent(studentData);
      fetchExams(studentData.class_id);
      fetchLeaderboard(studentData.class_id);
    }

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchExams = async (classId) => {
    try {
      const res = await axios.get(`https://api.scannscore.com/get_exam/${classId}`);
      const openExams = res.data
        .filter((exam) => exam.status === "open")
        .sort((a, b) => new Date(b.date) - new Date(a.date))
        .slice(0, 4); 
      setExams(openExams);
    } catch (error) {
      console.error("Error fetching exams:", error);
    }
  };

//   const fetchLeaderboard = async (classId) => {
//     try {
//       const res = await axios.get(`https://api.scannscore.com/leaderboard-class-wise/${classId}`);
//       const results = res.data;
   
//       const aggregated = results.reduce((acc, item) => {
//         if (!acc[item.student_id]) {
//           acc[item.student_id] = {
//             student_id: item.student_id,
//             student_name: item.student_name,
//             student_roll_no: item.student_roll_no,
//             totalScore: 0,
//           };
//         }
//         acc[item.student_id].totalScore += item.score;
//         return acc;
//       }, {});

//       const leaderboardArr = Object.values(aggregated).sort((a, b) => b.totalScore - a.totalScore);
//       // const currentStudentIndex = leaderboardArr.findIndex((s) => s.student_id === student?.id);
//     const currentStudentIndex = leaderboardArr.findIndex(
//   (s) => String(s.student_id) === String(student?.id)
// );
    
    
//       const currentStudent = leaderboardArr[currentStudentIndex];

//       setLeaderboard(leaderboardArr);
//       setCurrentStudentScore(currentStudent?.totalScore || 0);
//       setCurrentStudentRank(currentStudentIndex + 1 || 0);
//     } catch (err) {
//       console.error("Error fetching leaderboard:", err);
//     }
//   };

const fetchLeaderboard = async (classId) => {
  try {
    const studentData = JSON.parse(localStorage.getItem("student"));

    const res = await axios.get(
      `https://api.scannscore.com/leaderboard-class-wise/${classId}`
    );

    const results = res.data;

    const aggregated = results.reduce((acc, item) => {
      if (!acc[item.student_id]) {
        acc[item.student_id] = {
          student_id: item.student_id,
          student_name: item.student_name,
          student_roll_no: item.student_roll_no,
          totalScore: 0,
        };
      }

      acc[item.student_id].totalScore += item.score;

      return acc;
    }, {});

    const leaderboardArr = Object.values(aggregated).sort(
      (a, b) => b.totalScore - a.totalScore
    );

    // FIX HERE
    const currentStudentIndex = leaderboardArr.findIndex(
      (s) => String(s.student_id) === String(studentData?.id)
    );

    const currentStudent = leaderboardArr[currentStudentIndex];

    setLeaderboard(leaderboardArr);
    setCurrentStudentScore(currentStudent?.totalScore || 0);
    setCurrentStudentRank(
      currentStudentIndex >= 0 ? currentStudentIndex + 1 : 0
    );
  } catch (err) {
    console.error("Error fetching leaderboard:", err);
  }
};

  if (!student) {
    return <h3 className="text-center mt-20">Loading...</h3>;
  }

  const isMobile = windowWidth < 768;

  return (
    <div className="dashboard-container" style={{ padding: "2rem", background: "#f3f4f6", minHeight: "100vh", display: "flex", flexDirection: "column", gap: "2rem" }}>
      
      {/* TOP CARDS */}
      <div className={`dashboard-top-cards`} style={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: "2rem" }}>
        
        {/* STUDENT INFO CARD */}
        <div style={{ flex: 1, background: "#fff", borderRadius: "16px", padding: "2rem", boxShadow: "0 10px 25px rgba(0,0,0,0.1)", display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: "center", gap: "1.5rem", transition: "all 0.3s" }}>
          <img
            src={avatarImg}
            alt="Student Avatar"
            style={{ width: "120px", height: "120px", borderRadius: "50%", objectFit: "cover", boxShadow: "0 4px 15px rgba(0,0,0,0.1)" }}
          />
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", lineHeight: "1.8", fontSize: "15px", fontWeight: 500, textAlign: isMobile ? "center" : "left" }}>
            <p className="my-0"><span style={{ color: "#555" }}>Name:</span> <span style={{ fontWeight: 700, color: "#111" }}>{student.name || 'Student'}</span></p>
            <p className="my-0"><span style={{ color: "#555" }}>Roll No:</span> <span style={{ fontWeight: 700, color: "#111" }}>{student.roll_no}</span></p>
            <p className="my-0"><span style={{ color: "#555" }}>Class/ Course:</span> <span style={{ fontWeight: 700, color: "#111" }}>{student.class_name}</span></p>
            <p className="my-0"><span style={{ color: "#555" }}>Phone:</span> <span style={{ fontWeight: 700, color: "#111" }}>{student.phone}</span></p>
            <p className="my-0"><span style={{ color: "#555" }}>Email:</span> <span style={{ fontWeight: 700, color: "#111" }}>{student.email || "N/A"}</span></p>
          </div>
        </div>

        {/* RANK CARD */}
        <div style={{ flex: 1, background: "#fff", borderRadius: "16px", padding: "2rem", boxShadow: "0 10px 25px rgba(0,0,0,0.08)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", transition: "all 0.3s" }}>
          <FaTrophy style={{ fontSize: "50px", color: "#fbbf24", marginBottom: "0.5rem" }} />
          <h3 style={{ marginBottom: "0.5rem", fontWeight: 600 }}>Your Rank</h3>
          {/* <h2 style={{ color: "#4f46e5", fontWeight: 700, margin: 0 }}>{currentStudentScore} Points</h2> */}
          <p style={{color: "#4f46e5", fontWeight: 700, margin: 0  }}>Rank: {currentStudentRank}</p>
        </div>
      </div>

      {/* UPCOMING EXAMS */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <h2 style={{ marginBottom: "1.5rem", fontWeight: 700 }}>Upcoming Exams</h2>
        {exams.length === 0 ? (
          <p style={{ color: "#777" }}>No upcoming exams</p>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(200px, 1fr))", gap: "1.5rem", width: "100%", maxWidth: "900px" }}>
            {exams.map((exam) => (
              <div
                key={exam.id}
                style={{
                  background: "#fff",
                  padding: "1.5rem",
                  borderRadius: "12px",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.05)",
                  cursor: "pointer",
                  transition: "all 0.3s",
                  textAlign: "center",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px) scale(1.02)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0) scale(1)")}
              >
                <h3 style={{ marginBottom: "0.5rem", fontWeight: 600 }}>{exam.exam_title || exam.name}</h3>
                <span
                  style={{
                    color: "#fff",
                    padding: "6px 12px",
                    borderRadius: "8px",
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    background: exam.status === "open" ? "#22c55e" : "#f59e0b",
                  }}
                >
                  {exam.status.toUpperCase()}
                </span>
              </div>
            ))}
          </div>
        )}  
      </div>
    </div>
  );
}

export default Dashboard;